import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLeadGenerated: typeof window !== "undefined" ? localStorage.getItem("leadSubmitted") === "true" : false,
};

const leadSlice = createSlice({
  name: "lead",
  initialState,
  reducers: {
    markLeadAsGenerated: (state) => {
      state.isLeadGenerated = true;
      if (typeof window !== "undefined") {
        localStorage.setItem("leadSubmitted", "true");
      }
    },
  },
});

export const { markLeadAsGenerated } = leadSlice.actions;
export default leadSlice.reducer;
